import { render, staticRenderFns } from "./ItemMail.vue?vue&type=template&id=bce023b0&scoped=true&"
import script from "./ItemMail.vue?vue&type=script&lang=js&"
export * from "./ItemMail.vue?vue&type=script&lang=js&"
import style0 from "./ItemMail.vue?vue&type=style&index=0&id=bce023b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce023b0",
  null
  
)

export default component.exports